/*eslint-disable */
import GenericLapTop from 'assets/images/GenericLaptop.png';
import { REST_METHOD, REST_URL } from './../constants';
import { requestAsset, requestDeviceManagement, requestProvisioning } from './api';
import store from 'redux/store';
import baseAction from 'redux/actions/baseAction';

export const listState = {
  NORMAL_STATE: 'NORMAL_STATE',
  REFRESH_ELIGIBLE_STATE: 'REFRESH_ELIGIBLE_STATE',
  RETURN_STATE: 'RETURN_STATE',
};

export const CONSTANTS = {
  IN_USE: 'In use',
  ELIGIBLE_FOR_REFRESH: 'ELIGIBLE_FOR_REFRESH',
  NOT_APPLICABLE: 'N/A',
};

export const defaultCountries = {
  IND: "IND",
  BGR: "BGR",
};

const DeviceServices = {
  getPCResfreshStatus: async (user_name: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.CMDB}${REST_URL.MY_ASSETS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { user_name: user_name },
      };
      let response = await requestAsset(requestParams);

      if (!response.data) {
        return;
      }

      response = response.data;

      response = response.map((item: any) => {
        if (!item.model_picture) {
          item.model_picture = GenericLapTop;
        }

        // set config
        item.configuration = {};
        item.configuration.since = item.assigned_date
          ? item.assigned_date
          : CONSTANTS.NOT_APPLICABLE;
        item.configuration.osLicence = item.os
          ? item.os
          : CONSTANTS.NOT_APPLICABLE;
        item.configuration.lastActive = item.last_active
          ? item.last_active
          : CONSTANTS.NOT_APPLICABLE;

        return item;
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  getAssetStatusById: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.CMDB}${REST_URL.GET_ASSET_BY_ID}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { ...params },
      };

      const response = await requestAsset(requestParams);
      const result = response.data.map((item: any) => {
        if (!item.model_picture) {
          item.model_picture = GenericLapTop;
        }
        item.configuration = {};
        item.configuration.osLicence = item.os
          ? item.os
          : CONSTANTS.NOT_APPLICABLE;

        item.configuration.lastActive = !item.last_active
          ? CONSTANTS.NOT_APPLICABLE
          : item.last_active;
        item.configuration.since = item.assigned_date
          ? item.assigned_date
          : CONSTANTS.NOT_APPLICABLE;
        return item;
      });
      return result;
    } catch (error) {
      return [];
    }
  },

  getEligibleRefreshAssets: async (params: any, countriesMultiDepot = defaultCountries) => {
    try {
      const requestParams = {
        url: `${REST_URL.CMDB}${REST_URL.ELIGIBLE_REFRESH_ASSETS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          ...params,
          user_uid: params.user_uid ? params.user_uid : '',
          requestor_uid: countriesMultiDepot.hasOwnProperty(
            params.country?.toUpperCase(),
          )
            ? params.requestor_uid
              ? params.requestor_uid
              : ''
            : '',
          asset: params.asset ? params.asset : '',
        },
      };
      const response = await requestAsset(requestParams);

      const result = response.data.map((item: any) => {
        if (!item.picture) item.picture = GenericLapTop;
        return item;
      });

      return result;
    } catch (error) {
      return [];
    }
  },

  getBySerialNumber: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.GET_BY_SERIAL_NUMBER}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { ...params },
      };
      let response = await requestAsset(requestParams);
      if (!response.data) {
        return;
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  getMyNewDeviceAssetRequests: async (user_name: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.GET_MY_NEW_DEVICE_ASSET_REQUESTS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { user_name: user_name },
      };
      let response = await requestAsset(requestParams);

      if (!response.data) {
        return;
      }

      response = response.data;

      response = response.map((item: any) => {
        if (!item.model_picture) {
          item.model_picture = GenericLapTop;
        }

        // set config
        item.configuration = {};
        item.configuration.since = item.assigned_date
          ? item.assigned_date
          : CONSTANTS.NOT_APPLICABLE;
        item.configuration.osLicence = item.os
          ? item.os
          : CONSTANTS.NOT_APPLICABLE;
        item.configuration.lastActive = item.last_active
          ? item.last_active
          : CONSTANTS.NOT_APPLICABLE;

        return item;
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkAssignedDevice: async (user_name: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.CHECK_ASSIGNED_DEVICE}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { user_name: user_name },
      };
      let response = await requestAsset(requestParams);
      if (!response.data) {
        return;
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkAvailableModelDevice: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.CMDB}${REST_URL.AVAILABLE_DEVICE_MODEL}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { ...params },
      };
      let response = await requestAsset(requestParams);
      if (!response.data) {
        return;
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDevicesByManager: async (
    params: {
      search: string;
      sort: string;
      performance: string;
      status: string;
    },
    id: string,
  ) => {
    try {
      const requestParams = {
        url:
          REST_URL.ASSET +
          REST_URL.MANAGERS +
          '/' +
          id +
          REST_URL.EMPLOYEES +
          REST_URL.DEVICES,
        method: REST_METHOD.GET,
        queryParams: { ...params },
      };
      let response = await requestAsset(requestParams);
      if (!response.data) {
        return;
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  getMetricsHistory: async (fqdn: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.DEVICE_MANAGEMENT}${REST_URL.METRICS_HISTORY}`,
        method: REST_METHOD.GET,
        queryParams: { fqdn },
      };
      const response = await requestDeviceManagement(requestParams);
      return response.data ?? {};
    } catch (error: any) {
      const responseData = error?.response?.data || {};
      const message = responseData?.message || '';
      if (message) {
        store.dispatch(baseAction.errorHandling({ message }));
      }
      console.error(error);
      throw error;
    }
  },
  getListVirtual: async (email: string) => {
    try{
      const requestParams = {
        url: `${REST_URL.GET_VIRTUAL_USER}/${email}${REST_URL.GET_LIST_VIRTUAL_DESKTOP}`,
        method: REST_METHOD.GET,
      }
      const response = await requestProvisioning(requestParams);
      if (!response.data) {
        return;
      }
      return response.data;
    }
    catch(error) {
      throw error
    }
  },

  releaseResource: async (param:any) => {
    try{
      const requestParams = {
        url: `${REST_URL.RESOURCE}${REST_URL.RELEASE}`,
        method: REST_METHOD.POST,
        data: param
      }
      const response = await requestProvisioning(requestParams);
      if (!response.data) {
        return;
      }
      return response.data;
    }
    catch(error) {
      throw error
    }
  },

  getEmployeesVirtualDevices: async ({
    search,
    sort,
    performance,
    status,
    userId,
  }: {
    search: string;
    sort: string;
    performance: string;
    status: string;
    userId: string;
  }) => {
    const requestParams = {
      url: `${REST_URL.ASSET}${REST_URL.MANAGERS}/${userId}${REST_URL.EMPLOYEES_DEVICES}`,
      method: REST_METHOD.GET,
      queryParams: {
        search,
        sort,
        performance,
        status,
      },
    };
    const response = await requestAsset(requestParams);
    return response.data;
  },
};

export default DeviceServices;

